import React, { Component } from 'react'
import '../styles/footer.css'

class Footer extends Component {
  render () {
    return (
      <footer>
        <a href='https://www.google.com/maps/place/e-Innovation+Centre/@52.6852332,-2.4286249,15z/data=!4m5!3m4!1s0x0:0x5b4391b32d2e1632!8m2!3d52.6844788!4d-2.4247196' target='_blank' rel='noopener'>
          <i className='logo ac ac-bronzelabs' />
        </a>
        <p>Bronze Software Labs</p>
        <p>Contact us on <a href='tel:+441952288215'>+44(0)1952 288 215</a> or at <a href='mailto:info@bronzelabs.co.uk'>info@bronzelabs.co.uk</a></p>
        <p>e-Innovation Centre, Priorslee, Telford, Shropshire. TF2 9FT</p>
        <div id='footerLinks'>
          <a href='https://play.google.com/store/apps/developer?id=Bronze+Software+Labs+Ltd&hl=gb' target='_blank' rel='noopener'><i className='ac ac-android' /></a>
          <a href='https://itunes.apple.com/gb/developer/bronze-software-labs/id562914256' target='_blank' rel='noopener'><i className='ac ac-apple' /></a>
          <a href='https://twitter.com/bronzelabs'><i className='ac ac-twitter' target='_blank' rel='noopener' /></a>
          <a href='https://www.facebook.com/bronzelabs'><i className='ac ac-facebook' target='_blank' rel='noopener' /></a>
          <a href='http://vimeo.com/bronzelabs'><i className='ac ac-vimeo' target='_blank' rel='noopener' /></a>
          <a href='http://www.linkedin.com/company/bronze-software-labs' target='_blank' rel='noopener'><i className='ac ac-linkedin' /></a>
          <a href='https://plus.google.com/114531373620020736190/' target='_blank' rel='noopener'><i className='ac ac-google-plus' /></a>
        </div>
      </footer>
    )
  }
}
export default Footer



// WEBPACK FOOTER //
// ./src/components/Footer.js